import React, { useEffect, useState } from 'react';
import { Container } from '../styles/SurveyStyles';
import styled from 'styled-components';
import LogoImage from '../../../assets/images/Logo blue.png';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;
`;

const LoadingMessage = styled.h2`
  margin-top: 20px;
  color: ${props => props.themeColors?.highlightText || '#777'};
  font-size: 16px;
  font-weight: 500;
  opacity: 0.8;
`;

const LoadingSubMessage = styled.p`
  margin-top: 10px;
  color: ${props => props.themeColors?.text || '#666'};
  font-size: 16px;
`;

const Logo = styled.img`
  width: 200px;
  opacity: ${props => props.opacity};
  transition: opacity 1.5s ease-in-out;
`;

const SurveyLoader = ({ status, themeColors }) => {
  const [opacity, setOpacity] = useState(0);
  
  useEffect(() => {
    // Trigger the fade-in effect after component mounts
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container themeColors={themeColors}>
      <LoadingContainer>
        <Logo 
          src={LogoImage} 
          alt="InnerLogic Logo" 
          opacity={opacity}
        />
        <LoadingMessage themeColors={themeColors}>{status}</LoadingMessage>
      </LoadingContainer>
    </Container>
  );
};

export default SurveyLoader; 